import { Text } from "@chakra-ui/react";

function Title({ label, ...props }: { label: string } & Record<string, any>){
    return(
        <Text fontSize={18} fontWeight="bold" mb={6} {...props} >
            {label}
        </Text>
    )    
}

export default Title;